export default function LoginButton() {
    const apiUrl = process.env.REACT_APP_API_URL;

    return (
        <a href={`${apiUrl}/auth/gitlab`}>
            <button>Login with GitLab</button>
        </a>
    );
}